(function () {
  function parseGapPx(track) {
    const g = getComputedStyle(track).gap || getComputedStyle(track).columnGap;
    const n = parseFloat(g);
    return Number.isFinite(n) ? n : 12;
  }

  function scrollStep(track) {
    const slide = track.querySelector('.cart-notification__upsells-slide');
    if (!slide) return track.clientWidth;
    return slide.getBoundingClientRect().width + parseGapPx(track);
  }

  function isTrackMeasurable(track) {
    const root = track?.closest('#cart-notification-upsells');
    if (!root || root.classList.contains('hidden')) return false;
    return track.clientWidth > 0;
  }

  function updateNavState(track, prev, next) {
    if (!track || !prev || !next) return;

    if (!isTrackMeasurable(track)) {
      requestAnimationFrame(() => updateNavState(track, prev, next));
      return;
    }

    const max = track.scrollWidth - track.clientWidth;
    const left = track.scrollLeft;
    const eps = 2;
    const canScroll = max > eps;

    prev.disabled = !canScroll || left <= eps;
    next.disabled = !canScroll || left >= max - eps;
    prev.classList.toggle('is-disabled', prev.disabled);
    next.classList.toggle('is-disabled', next.disabled);
  }

  function scheduleNavUpdate(track, prev, next) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => updateNavState(track, prev, next));
    });
  }

  function bindCarousel(root) {
    const track = root.querySelector('#cart-notification-upsells-track');
    const prev = root.querySelector('.cart-notification__upsells-nav--prev');
    const next = root.querySelector('.cart-notification__upsells-nav--next');
    if (!track || !prev || !next) return;

    if (root._upsellsCarouselTrack === track && root.dataset.upsellsCarouselBound === 'true') {
      scheduleNavUpdate(track, prev, next);
      return;
    }

    root._upsellsCarouselTrack = track;
    root.dataset.upsellsCarouselBound = 'true';

    const onScroll = () => updateNavState(track, prev, next);

    prev.addEventListener('click', () => {
      track.scrollBy({ left: -scrollStep(track), behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      track.scrollBy({ left: scrollStep(track), behavior: 'smooth' });
    });
    track.addEventListener('scroll', onScroll, { passive: true });

    window.addEventListener(
      'resize',
      () => {
        updateNavState(track, prev, next);
      },
      { passive: true }
    );

    scheduleNavUpdate(track, prev, next);
  }

  function tryBind() {
    const root = document.getElementById('cart-notification-upsells');
    if (!root || root.classList.contains('hidden')) return;
    bindCarousel(root);
  }

  function onCartNotificationOpened() {
    requestAnimationFrame(() => {
      const root = document.getElementById('cart-notification-upsells');
      if (!root || root.classList.contains('hidden')) return;

      const track = root.querySelector('#cart-notification-upsells-track');
      const prev = root.querySelector('.cart-notification__upsells-nav--prev');
      const next = root.querySelector('.cart-notification__upsells-nav--next');

      if (track) track.scrollLeft = 0;
      bindCarousel(root);
      if (track && prev && next) scheduleNavUpdate(track, prev, next);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryBind);
  } else {
    tryBind();
  }

  document.addEventListener('cart-notification:opened', onCartNotificationOpened);
})();
